import { makeStyles, MenuItem } from "@material-ui/core";
import { FilterList } from "@material-ui/icons";
import {
  FilterMenu,
  FilterSearch,
} from "@ofqual/portal-components/components/ResponseFilter";
import { Select } from "@ofqual/portal-components/components/Select";
import { SearchCoreMethods, useLookup } from "@ofqual/portal-core/core/hooks";
import React from "react";
import {
  apprenticeshipStandardsService,
  inclusionExclusionService,
  levelsService,
  permissionTypesService,
  qualificationTypeService,
  sectorSubjectAreaService,
  technicalQualSubjectService,
} from "../../services";
import { fieldLabels } from "./fieldLabels";

const useStyles = makeStyles((theme) => {
  return {
    root: {
      "& fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    menuItem: {
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    button: {
      color: "black",
    },
  };
});

export const ScopesFilterMenu: React.FC<{ search: SearchCoreMethods }> = ({
  search,
}) => {
  const classes = useStyles();

  const [
    includeExcludeLookups,
    permissionTypesLookups,
    qualTypeLookups,
    levelsLookups,
    sectorSubjectAreaLookups,
    technicalQualSubjectLookups,
    apprenticeshipStandardsLookups,
  ] = useLookup(
    inclusionExclusionService,
    {
      service: permissionTypesService,
      id: "id",
      label: "description",
    },
    {
      service: qualificationTypeService,
      id: "id",
      label: "description",
    },
    {
      service: levelsService,
      id: "id",
      label: "levelValue",
    },
    sectorSubjectAreaService,
    {
      service: technicalQualSubjectService,
      id: "id",
      label: "description",
    },
    {
      service: apprenticeshipStandardsService,
      id: "id",
      label: "title",
    }
  );

  return (
    <>
      <FilterSearch
        title="Search..."
        value={search.searchParamsFiltersOnly.search}
        onChange={(value) => search.navigateToNextSearch({ search: value })}
        dataTest="search"
        variant="dark"
      />
      &nbsp;&nbsp;
      <FilterMenu
        Icon={FilterList}
        title="Filters"
        classNameButton={classes.button}
        search={search}
      >
        {(workingParams, dirtyParams, addParam) => (
          <form>
            <MenuItem className={classes.menuItem}>
              <Select
                className={
                  dirtyParams.includes("inclusionExclusion")
                    ? classes.root
                    : undefined
                }
                label={fieldLabels.inclusionExclusion}
                datatest="inclusion-exclusion-filter"
                value={workingParams.inclusionExclusion}
                onChange={(e) => addParam("inclusionExclusion", e.target.value)}
              >
                {includeExcludeLookups}
              </Select>
            </MenuItem>
            <MenuItem className={classes.menuItem}>
              <Select
                className={
                  dirtyParams.includes("recognitionPermissionType")
                    ? classes.root
                    : undefined
                }
                label={fieldLabels.recognitionPermissionType}
                datatest="recognition-permission-type-filter"
                value={workingParams.recognitionPermissionType}
                onChange={(e) =>
                  addParam("recognitionPermissionType", e.target.value)
                }
              >
                {permissionTypesLookups}
              </Select>
            </MenuItem>
            <MenuItem className={classes.menuItem}>
              <Select
                className={
                  dirtyParams.includes("qualificationType")
                    ? classes.root
                    : undefined
                }
                label={fieldLabels.qualificationType}
                datatest="qualification-type-filter"
                value={workingParams.qualificationType}
                onChange={(e) => addParam("qualificationType", e.target.value)}
              >
                {qualTypeLookups}
              </Select>
            </MenuItem>
            <MenuItem className={classes.menuItem}>
              <Select
                className={
                  dirtyParams.includes("level") ? classes.root : undefined
                }
                label={fieldLabels.level}
                datatest="level-filter"
                value={workingParams.level}
                onChange={(e) => addParam("level", e.target.value)}
              >
                {levelsLookups}
              </Select>
            </MenuItem>
            <MenuItem className={classes.menuItem}>
              <Select
                className={
                  dirtyParams.includes("sectorSubjectArea")
                    ? classes.root
                    : undefined
                }
                label={fieldLabels.sectorSubjectArea}
                datatest="ssa-filter"
                value={workingParams.sectorSubjectArea}
                onChange={(e) => addParam("sectorSubjectArea", e.target.value)}
              >
                {sectorSubjectAreaLookups}
              </Select>
            </MenuItem>
            <MenuItem className={classes.menuItem}>
              <Select
                className={
                  dirtyParams.includes("tLevelSubject")
                    ? classes.root
                    : undefined
                }
                label={fieldLabels.tLevelSubject}
                datatest="t-level-subject-filter"
                value={workingParams.tLevelSubject}
                onChange={(e) => addParam("tLevelSubject", e.target.value)}
              >
                {technicalQualSubjectLookups}
              </Select>
            </MenuItem>
            <MenuItem className={classes.menuItem}>
              <Select
                className={
                  dirtyParams.includes("apprenticeshipStandard")
                    ? classes.root
                    : undefined
                }
                label={fieldLabels.apprenticeshipStandard}
                datatest="apprenticeship-standard-filter"
                value={workingParams.apprenticeshipStandard}
                onChange={(e) =>
                  addParam("apprenticeshipStandard", e.target.value)
                }
              >
                {apprenticeshipStandardsLookups}
              </Select>
            </MenuItem>
            <MenuItem className={classes.menuItem}>
              <Select
                className={
                  dirtyParams.includes("active") ? classes.root : undefined
                }
                label="Active/Inactive"
                datatest="active-inactive-filter"
                value={workingParams.active}
                onChange={(e) => addParam("active", e.target.value)}
              >
                {[
                  {
                    id: true,
                    label: "Active",
                  },
                  {
                    id: false,
                    label: "Inactive",
                  },
                ]}
              </Select>
            </MenuItem>
          </form>
        )}
      </FilterMenu>
    </>
  );
};
